<template>
<div class="chapter">
<div class="inner_page">
<h1 class="plm_hd"><a href="#/Text/REV_contents">Chief abbreviations</a></h1>
<p class="abb_fo"><span class="roman">AG</span> – <em class="italic">A Greek–English Lexicon of the New Testament and Other Early Christian Literature </em>by William F. Arndt and F. Wilbur Gingrich (University of Chicago Press and Cambridge University Press, 1957).</p>
<p class="abb_fo"><span class="smallcaps">av</span> – <span class="roman">The Authorized </span>(King James) <span class="roman">Version </span>of the Bible (1611).</p>
<p class="abb_fo">Caird – <em class="italic">The Revelation of St John the Divine</em> by G. B. Caird (A. and C. Black, 1966).</p>
<p class="abb_fo">Farrer – <em class="italic">The Revelation of St John the Divine</em> by Austin Farrer (Oxford University Press, 1964).</p>
<p class="abb_fo">Glasson – <em class="italic">The Revelation of John</em> by T. F. Glasson (<span class="roman">The Cambridge Bible Commentary on the New English Bible</span>, Cambridge University Press, 1965).</p>
<p class="abb_fo"><span class="smallcaps">jb</span> – <span class="roman">The Jerusalem Bible </span>(Darton, Longman and Todd, 1966).</p>
<p class="abb_fo"><span class="smallcaps">jbp</span> – <em class="italic">The New Testament in Modern English</em> by J. B. Phillips (Collins, 1958).</p>
<p class="abb_fo">Kiddle – <em class="italic">The Revelation of St John</em> by Martin Kiddle (<span class="roman">The Moffatt New Testament Commentary</span>, Hodder and Stoughton, 1940).</p>
<p class="abb_fo">Knox – <em class="italic">The New Testament of our Lord and Saviour Jesus Christ</em> translated by Ronald Knox (Burns, Oates and Washbourne, 1946).</p>
<p class="abb_fo">Maycock – <em class="italic">The Apocalypse</em> by A. L. Maycock (Dacre Press, n.d.).</p>
<p class="abb_fo">Morris – <em class="italic">The Revelation of St John</em> by Leon Morris (<span class="roman">Tyndale New Testament Commentaries</span>, Inter-Varsity Press, 1969).</p>
<p class="abb_fo"><span class="smallcaps">neb</span> – <span class="roman">The New English Bible </span>(New Testament, 1961; Old Testament, 1970).</p>
<p class="abb_fo"><span class="smallcaps">nrsv – </span>The New Revised Standard Version of the Bible (1989, 1995).</p>
<p class="abb_fo"><span class="smallcaps">rsv</span> – <span class="roman">The Revised Standard Version</span> of the Bible (New Testament, 1946; Old Testament, 1952; revised edition, 1995).</p>
<p class="abb_fo"><span class="smallcaps">rv</span> – <span class="roman">The Revised Version </span>of the Bible (1885).</p>
<p class="abb_fo">Swete – <em class="italic">The Apocalypse of St John</em> by H. B. Swete (Macmillan, third edition, 1911).</p>
<p class="abb_fo">Walvoord – <em class="italic">The Revelation of Jesus Christ</em> by John F. Walvoord (Marshall, Morgan and Scott, 1966).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// REV_abbrev.vue?675376e2